"use strict";

import _, { map } from 'underscore';

// SEGMENT WRAPPER
export let Segment = (function() {

    var defaults = {
        // initiate only for live application -> don't want to mix debug & development with local
        isLive: false
    };
    var methods = {
        init: function() {
            // don't initialize for debugging
            if (!defaults.isLive)
                return;
            //var analytics = window.analytics = window.analytics || [];
            //if (!analytics.initialize)
            //    if (analytics.invoked)
            //        window.console && console.error && console.error("Segment snippet included twice.");
            //    else {
            //        analytics.invoked = true;
            //        analytics.methods = [
            //            "trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group",
            //            "track", "ready", "alias", "page", "once", "off", "on"
            //        ];
            //        analytics.factory = function (t) {
            //            return function () {
            //                var e = Array.prototype.slice.call(arguments);
            //                e.unshift(t);
            //                analytics.push(e);
            //                return analytics;
            //            }
            //        };

            //        for (var t = 0; t < analytics.methods.length; t++) {
            //            var e = analytics.methods[t];
            //            analytics[e] = analytics.factory(e);
            //        }

            //        analytics.load = function (t) {
            //            var e = document.createElement("script");
            //            e.type = "text/javascript";
            //            e.async = true;
            //            e.src = ("https:" === document.location.protocol ? "https://" : "http://") +
            //                "cdn.segment.com/analytics.js/v1/" +
            //                t +
            //                "/analytics.min.js";
            //            var n = document.getElementsByTagName("script")[0];
            //            n.parentNode.insertBefore(e, n);
            //        };

            //        analytics.SNIPPET_VERSION = "4.1.0";
            //        analytics.load("PnazJgn9qE8j1kvYIwEedXOHDOJrGoeo");
            //        analytics.page();
            //    }
        },
        // properties are optional
        track: function(message, properties, integrations) {
            try {
                if (message === "0-day upgrade") {
                    ga("send", "event", {
                        'eventAction': message,
                        'eventCategory': properties["category"],
                        'eventLabel': properties["label"]
                    });
                }
                if (message === "Features popup - Accepted" || message === "Features popup - ended without showing modal") {
                    ga("send", "event", {
                        'eventAction': "Features popup - Accepted",
                        'eventCategory': properties["category"],
                        'eventLabel': properties["label"]
                    });
                }
            } catch (e) {
                console.error("ga: sending event failed");
            }

            if (defaults.isLive) {
                //var analytics = window.analytics;
                //if (analytics) {
                //    //if(properties)
                //    //    analytics.track(message, properties);
                //    //else
                //    //    analytics.track(message);
                //    analytics.track(message, properties, integrations);
                //}
                //else {
                //    console.error("Segment is not initialized.");
                //}

                var mixpanel = window.mixpanel;
                if (mixpanel && (integrations.integrations.All || integrations.integrations.Mixpanel)) {
                    mixpanel.track(message, properties);
                } else {
                    console.error("Mixpanel is not initialized.");
                }

            }
            else {
                console.log("[debugger] Segment Track: " + message, properties);
            }
        }
    };

    function Segment() {
        methods.init();
    };

    // public methods
    Segment.prototype.setEnvironment = function(isLive) {
        defaults.isLive = isLive;
    };

    Segment.prototype.init = function() {
        return methods.init();
    };

    Segment.prototype.on = function(eventName, eventFunction) {
        if (window.analytics)
            window.analytics.on(eventName, eventFunction);
    };

    Segment.prototype.identify = function(userEmail, userProperties, integrations) {
        if (window.analytics) {
            if (defaults.isLive) {
                window.analytics.identify(userEmail, userProperties, integrations);
            } else {
                console.log("Analytics identified with " + userEmail);
            }
        }

        if (window.mixpanel) {
            if (defaults.isLive) {
                window.mixpanel.identify(userEmail);
            } else {
                console.log("Mixpanel identified with " + userEmail);
            }
        }
    };

    Segment.prototype.track = function(message, properties) {
        // we need send to intercom only event with "label" in properties as event name
        //if (properties != null && properties.hasOwnProperty("label") && typeof Intercom !== 'undefined') {
        //Intercom("trackEvent", properties["label"], properties);
        //}

        if (!properties) {
            properties = {};
        }

        if (window.UserPlanName) {
            properties["UserPlanId"] = window.UserPlanName;
        }

        if (typeof NjoApp !== "undefined" && !_.isUndefined(NjoApp.IsTrial)) {
            properties["UserIsTrial"] = NjoApp.IsTrial;
        }

        if (!_.isUndefined(window.IsMasterUser)) {
            properties["UserIsSubuser"] = !window.IsMasterUser;
        }

        // Since we sent event to intercom - send to all other destination
        var integrationsObject = {
            integrations: {
                'All': true,
                'Intercom': false
            }
        };
        return methods.track(message, properties, integrationsObject);
    };

    Segment.prototype.trackMixpanel = function(message, properties) {
        var integrationsObject = {
            integrations: {
                'All': false,
                'Mixpanel': true
            }
        };

        if (window.UserPlanName) {
            properties["UserPlanId"] = window.UserPlanName;
        }

        return methods.track(message, properties, integrationsObject);
    };

    Segment.prototype.trackActionEvent = function(message) {
        try {
            if (defaults.isLive) {
                //@* sh.sergey - userpilot was disabled*@
                //@* userpilot.track(message);*@
            }
            else {
                console.log("[debugger] UserPilot Track: " + message);
            }
        } catch (e) {
            console.log("Tracking action event is failed: " + message);
        }
    };


    Segment.prototype.trackSmartlook = function(message) {
        try {
            if (defaults.isLive) {
                smartlook('track', message);
            }
            else {
                console.log("[debugger] Smartlook Track: " + message);
            }
        } catch (e) {
            console.log("Tracking smartlook is failed: " + message);
        }
    };

    Segment.prototype.usercomEvent = function(eventName, eventProperties) {
        try {
            if (defaults.isLive) {
                userengage("event." + eventName, eventProperties);

                // there is example for further development
                //userengage("event.name",{
                //    event_attr1: "value1",
                //    event_attr2: "value2"
                //});
            } else {
                console.log("[debugger] User.com Event: " + eventName, eventProperties);
            }

        } catch (e) {
            console.log("User.com Event is failed: " + eventName, eventProperties);
        }
    };

    Segment.prototype.sendGaOnboardingEvent = function(eventLabel) {
        this.sendGaEvent("onboarding_flow", "click", eventLabel);
    };

    Segment.prototype.sendGaEvent = function(category, action, label) {
        try {
            if (defaults.isLive) {
                ga("send", "event", {
                    'eventCategory': category,
                    'eventAction': action,
                    'eventLabel': label
                });
            } else {
                console.log("[debugger] GA Event: "+ category + " - " + action + " - " + label);

            }
        } catch (e) {
            console.error("ga: sending event failed");
        }
    };

    return new Segment();
})();
